export default __webpack_public_path__ + "static/media/sk.95d3426a.svg";